import { Injectable, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UrlParamsModel } from '../../models/LocalServiceModels/UrlParamsModel';

@Injectable({
  providedIn: 'root'
})
export class UrlParamService {

  private UUID: string;

  private Source: string;

  private Agent: string;
  public Lang: string;

  public Token:string;

  public State:string;

  public UrlParams: UrlParamsModel;



  constructor(private activatedRoute: ActivatedRoute) {
    this.UUID = "UUID";
    this.Source = "source";
    this.Agent = "Agent";
    this.Lang = "lang";
    this.Token = "token";
    this.State = "state";
  }

  public getURLParams(): void {
    var agentCode = this.activatedRoute.snapshot.queryParams[this.Agent];
    var uuid = this.activatedRoute.snapshot.queryParams[this.UUID];
    var source = this.activatedRoute.snapshot.queryParams[this.Source];
    var lang = this.activatedRoute.snapshot.queryParams[this.Lang];
    var token = this.activatedRoute.snapshot.queryParams[this.Token];
    var state = this.activatedRoute.snapshot.queryParams[this.State];
    
    this.UrlParams = new UrlParamsModel(agentCode, uuid, source, lang, token, state);
  }
}
